export const featuredComics = [
  {
    id: 1,
    title: '剑与魔法',
    subtitle: 'Sword & Magic',
    category: '奇幻冒险',
    author: '金贤秀',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20adventure%20sword%20and%20magic%20cover%20art%2C%20epic%20illustration%20with%20warm%20golden%20tones%2C%20manga%20style%20character%20design%2C%20clean%20simple%20background%2C%20dramatic%20lighting%2C%20high%20quality%20digital%20art&width=800&height=1140&seq=comic-sword-magic-01&orientation=portrait',
    rating: 4.9,
    views: 1280000,
    chapters: 86,
    status: '连载中',
    description: '一位普通高中生意外穿越到剑与魔法的世界，在异世界展开惊心动魄的冒险旅程。少年林天在放学路上被神秘光芒笼罩，醒来时发现自己置身于一个充满魔法与剑术的奇幻大陆。在这里，他遇到了性格各异的伙伴，共同对抗黑暗势力的侵袭。',
    tags: ['热门', '异世界', '战斗'],
    updatedAt: '2026-07-03',
  },
  {
    id: 2,
    title: '都市恋人',
    subtitle: 'City Lovers',
    category: '恋爱都市',
    author: '李美英',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20city%20lovers%20cover%20art%2C%20young%20couple%20in%20urban%20setting%2C%20warm%20pink%20and%20cream%20tones%2C%20manga%20style%2C%20clean%20simple%20background%2C%20romantic%20atmosphere%2C%20soft%20lighting%2C%20high%20quality&width=800&height=1140&seq=comic-city-lovers-02&orientation=portrait',
    rating: 4.8,
    views: 960000,
    chapters: 52,
    status: '连载中',
    description: '在繁华都市中相遇的两个人，从陌生到熟悉，演绎一段甜蜜又虐心的都市爱情故事。女主人公苏晴是一名普通白领，一次偶然的机会在咖啡馆遇见了神秘的钢琴师，两人的命运从此交织。',
    tags: ['热恋', '甜宠', '都市'],
    updatedAt: '2026-07-02',
  },
  {
    id: 3,
    title: '暗夜猎手',
    subtitle: 'Night Hunter',
    category: '悬疑动作',
    author: '朴正宇',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20dark%20action%20thriller%20cover%20art%2C%20mysterious%20hunter%20character%2C%20noir%20atmosphere%2C%20deep%20shadow%20tones%2C%20manga%20style%2C%20clean%20composition%2C%20dramatic%20lighting%2C%20high%20quality%20illustration&width=800&height=1140&seq=comic-night-hunter-03&orientation=portrait',
    rating: 4.7,
    views: 850000,
    chapters: 64,
    status: '连载中',
    description: '夜幕降临，城市阴影中潜伏着不为人知的危险。一个神秘猎手挺身而出，揭开层层谜团。韩俊昊白天是一名普通记者，夜幕降临后则化身暗夜猎手，追踪城市中最危险的罪犯。',
    tags: ['热门', '悬疑', '动作'],
    updatedAt: '2026-07-01',
  },
  {
    id: 4,
    title: '天界之约',
    subtitle: "Heaven's Promise",
    category: '奇幻爱情',
    author: '崔恩熙',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20romance%20celestial%20theme%20cover%20art%2C%20ethereal%20beauty%2C%20dreamy%20pastel%20tones%2C%20manga%20style%20character%2C%20clean%20simple%20background%2C%20soft%20glowing%20lighting%2C%20high%20quality%20digital%20art&width=800&height=1140&seq=comic-heaven-promise-04&orientation=portrait',
    rating: 4.9,
    views: 1120000,
    chapters: 78,
    status: '连载中',
    description: '天界仙子与凡间少年的禁忌之恋，跨越天地的浪漫奇幻故事。天界最小的仙女云瑶因好奇偷偷下凡，不料在人间邂逅了善良正直的少年陆川，一段跨越天界的禁忌之恋悄然展开。',
    tags: ['奇幻', '爱情', '唯美'],
    updatedAt: '2026-07-03',
  },
  {
    id: 5,
    title: '重生之商道',
    subtitle: 'Rebirth Business',
    category: '职场逆袭',
    author: '姜东元',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20business%20rebirth%20office%20drama%20cover%20art%2C%20confident%20protagonist%20in%20suit%2C%20modern%20corporate%20aesthetic%2C%20warm%20amber%20tones%2C%20manga%20style%2C%20clean%20simple%20background%2C%20professional%20lighting&width=800&height=1140&seq=comic-rebirth-business-05&orientation=portrait',
    rating: 4.6,
    views: 720000,
    chapters: 45,
    status: '连载中',
    description: '曾经失败的企业家重生回到十年前，凭借前世记忆在商界掀起惊涛骇浪。徐振宇在破产后意外重生，带着十年后的记忆回到大学时代，这一次他誓要改写命运。',
    tags: ['重生', '职场', '逆袭'],
    updatedAt: '2026-06-30',
  },
  {
    id: 6,
    title: '校园风云录',
    subtitle: 'School Storm',
    category: '校园热血',
    author: '尹智勋',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20action%20drama%20cover%20art%2C%20dynamic%20youth%20characters%2C%20vibrant%20energy%2C%20warm%20bright%20tones%2C%20manga%20style%2C%20clean%20simple%20background%2C%20high%20quality%20illustration&width=800&height=1140&seq=comic-school-storm-06&orientation=portrait',
    rating: 4.5,
    views: 680000,
    chapters: 38,
    status: '连载中',
    description: '转学生来到新学校，凭借过人实力在校园中掀起一场热血风云。曾经是跆拳道全国冠军的郑宇因家庭变故转学到普通高中，低调的他却因一次意外事件不得不展现实力。',
    tags: ['校园', '热血', '友情'],
    updatedAt: '2026-06-29',
  },
];

export const categoryComics = [
  {
    id: 7,
    title: '魔王与勇者',
    subtitle: 'Demon King & Hero',
    category: '奇幻冒险',
    author: '韩俊基',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20demon%20king%20hero%20cover%20art%2C%20epic%20clash%20scene%2C%20warm%20dramatic%20tones%2C%20manga%20style%2C%20clean%20composition%2C%20high%20quality%20digital%20art&width=800&height=1140&seq=comic-demon-hero-07&orientation=portrait',
    rating: 4.8,
    views: 540000,
    chapters: 92,
    status: '连载中',
    description: '魔王与勇者的宿命对决，却意外发展出超越敌我的深厚羁绊。千年前被封印的魔王意外苏醒，却失去了大部分力量，而预言中的勇者竟然是一个尚未成年的少女。',
    tags: ['奇幻', '冒险', '友情'],
    updatedAt: '2026-07-02',
  },
  {
    id: 8,
    title: '我的邻居是明星',
    subtitle: 'My Celebrity Neighbor',
    category: '恋爱都市',
    author: '文彩英',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20celebrity%20neighbor%20cover%20art%2C%20charming%20characters%2C%20warm%20cozy%20tones%2C%20manga%20style%2C%20clean%20simple%20background%2C%20romantic%20lighting%2C%20high%20quality&width=800&height=1140&seq=comic-celebrity-neighbor-08&orientation=portrait',
    rating: 4.7,
    views: 780000,
    chapters: 56,
    status: '连载中',
    description: '当红明星搬到隔壁，平凡女孩的日常生活从此天翻地覆。李智恩的隔壁突然搬来了当红偶像团体成员，本想保持距离，却因为各种意外事件越走越近。',
    tags: ['恋爱', '明星', '甜宠'],
    updatedAt: '2026-07-01',
  },
  {
    id: 9,
    title: '修仙直播间',
    subtitle: 'Cultivation Live',
    category: '东方玄幻',
    author: '张天一',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cultivation%20fantasy%20martial%20arts%20cover%20art%2C%20mystical%20eastern%20aesthetic%2C%20warm%20golden%20and%20jade%20tones%2C%20manga%20style%2C%20clean%20simple%20background%2C%20ethereal%20lighting&width=800&height=1140&seq=comic-cultivation-live-09&orientation=portrait',
    rating: 4.6,
    views: 610000,
    chapters: 72,
    status: '连载中',
    description: '修仙界大佬穿越到现代，靠直播修仙日常火爆全网。曾经的仙尊林尘渡劫失败穿越到现代都市，为了适应这个世界他开起直播，没想到修仙日常竟然吸引了百万粉丝。',
    tags: ['修仙', '搞笑', '现代'],
    updatedAt: '2026-06-30',
  },
  {
    id: 10,
    title: '末日幸存者',
    subtitle: 'Apocalypse Survivor',
    category: '科幻末世',
    author: '赵成民',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20post%20apocalyptic%20survival%20cover%20art%2C%20dramatic%20ruins%20setting%2C%20earthy%20warm%20tones%2C%20manga%20style%2C%20clean%20composition%2C%20atmospheric%20lighting%2C%20high%20quality&width=800&height=1140&seq=comic-apocalypse-survivor-10&orientation=portrait',
    rating: 4.8,
    views: 890000,
    chapters: 48,
    status: '连载中',
    description: '末日降临，普通上班族在废墟中挣扎求生，寻找最后的希望。突如其来的病毒席卷全球，感染者变成了可怕的怪物。上班族金泰浩带着几个幸存者在这片废土中艰难求生。',
    tags: ['末世', '生存', '科幻'],
    updatedAt: '2026-07-03',
  },
  {
    id: 11,
    title: '医道至尊',
    subtitle: 'Medical Supreme',
    category: '职场逆袭',
    author: '孙明浩',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20medical%20drama%20doctor%20cover%20art%2C%20professional%20hospital%20setting%2C%20warm%20clean%20tones%2C%20manga%20style%2C%20simple%20background%2C%20bright%20professional%20lighting&width=800&height=1140&seq=comic-medical-supreme-11&orientation=portrait',
    rating: 4.5,
    views: 450000,
    chapters: 34,
    status: '连载中',
    description: '天才医生重回医疗界，用超凡医术征服整个医学界。曾被誉为医学天才的安在赫因医疗事故被开除，沉沦三年后他以全新姿态回归，用无人能及的医术重新证明自己。',
    tags: ['医疗', '逆袭', '都市'],
    updatedAt: '2026-06-28',
  },
  {
    id: 12,
    title: '魔法学院日常',
    subtitle: 'Magic Academy Daily',
    category: '奇幻冒险',
    author: '周智慧',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20magic%20academy%20school%20life%20cover%20art%2C%20magical%20young%20characters%2C%20warm%20enchanting%20tones%2C%20manga%20style%2C%20clean%20simple%20background%2C%20bright%20magical%20lighting&width=800&height=1140&seq=comic-magic-academy-12&orientation=portrait',
    rating: 4.7,
    views: 670000,
    chapters: 60,
    status: '连载中',
    description: '魔法学院的平凡日常，却处处充满惊喜与温馨。在赫赫有名的艾瑞斯魔法学院，一群性格各异的年轻魔法学徒的日常学习与生活故事，充满欢笑与感动。',
    tags: ['魔法', '学院', '日常'],
    updatedAt: '2026-07-02',
  },
];

export const allComics = [...featuredComics, ...categoryComics];

export const categories = [
  { id: 'fantasy', name: '奇幻冒险', icon: 'ri-sword-line', count: 1280, description: '剑与魔法的奇幻世界，热血冒险之旅' },
  { id: 'romance', name: '恋爱都市', icon: 'ri-heart-line', count: 960, description: '甜蜜浪漫的都市爱情故事' },
  { id: 'suspense', name: '悬疑动作', icon: 'ri-search-eye-line', count: 540, description: '扣人心弦的悬疑推理与精彩动作' },
  { id: 'school', name: '校园热血', icon: 'ri-building-line', count: 720, description: '青春热血的校园生活' },
  { id: 'workplace', name: '职场逆袭', icon: 'ri-briefcase-line', count: 380, description: '职场奋斗与人生逆袭' },
  { id: 'scifi', name: '科幻末世', icon: 'ri-rocket-line', count: 260, description: '科幻想象与末世生存' },
  { id: 'eastern', name: '东方玄幻', icon: 'ri-moon-line', count: 450, description: '修仙问道，东方玄幻奇缘' },
  { id: 'comedy', name: '搞笑日常', icon: 'ri-emotion-laugh-line', count: 610, description: '轻松搞笑，欢乐不断' },
];